// "Connect a bank" (Plaid Link via startLink), shared by Bank Feeds and
// Accounts. Shown only with bank_feeds.manage on the one selected business;
// hidden while several businesses are selected (a connection belongs to one).
// Without a business it is a personal connection, offered only when
// allowPersonal is set (Bank Feeds). OAuth banks return via /plaid/oauth.
import React, { useEffect, useState } from 'react';
import { bankFeedsAPI } from './bankFeedsApi';
import { startLink } from './plaidFlow';
import { canManageBankFeeds } from './bankFeedPermissions';
import { activeBusinessIds } from '../../utils/businessMulti';
import { formatApiError } from '../../utils/errorMessage';

export function connectAllowed({ businessId, permissions, allowPersonal = false, multiCount = 0 }) {
  if (multiCount >= 2) return false;
  if (!businessId) return Boolean(allowPersonal);
  return canManageBankFeeds(permissions, businessId);
}

export default function ConnectBankButton({ businessId = null, permissions, allowPersonal = false, disabled = false, onConnected, onItem, onError, className, style }) {
  const [loaded, setLoaded] = useState(permissions);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (permissions !== undefined) { setLoaded(permissions); return undefined; }
    let live = true;
    bankFeedsAPI.status()
      .then((s) => { if (live) setLoaded(s.data?.configured ? s.data.permissions : null); })
      .catch(() => { if (live) setLoaded(null); });
    return () => { live = false; };
  }, [permissions]);

  if (!connectAllowed({ businessId, permissions: loaded, allowPersonal, multiCount: activeBusinessIds().length })) return null;
  const connect = async () => {
    setBusy(true);
    try {
      const msg = await startLink('connect', { businessId, onItem });
      if (msg && onConnected) await onConnected(msg);
    } catch (e) {
      if (onError) onError(formatApiError(e, 'Could not connect the bank'));
    }
    setBusy(false);
  };
  return (
    <button type="button" onClick={connect} disabled={disabled || busy} className={className} style={style}>
      {busy ? 'Connecting…' : 'Connect a bank'}
    </button>
  );
}
